import styled from "styled-components";

export const AssetSelectionFieldStyled = styled.div``;

export const RenderTitleStyled = styled.div`
  color: ${({ theme }): string => theme.textColors.DARK_GREY_10};
  padding: 13px 13px 0 13px;
`;
